

import Api from "./Api";
import Csrf from "./Csrf";

export default { 
	
  async show(id) {
    await Csrf.getCookie();

    return Api.get("/rooms/"+id);
  },	
	
  async update(id,data) {
    await Csrf.getCookie();

    return Api.patch("/rooms/"+id,data);
  },	
};